import { useMemo } from 'react';

import PaymentElementsFormRefresh from '@/components/purchase/PaymentElementsFormRefresh';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';

import { buildCheckoutSessionsFlowConfig } from './flowConfig';
import type { CheckoutSessionsPaymentFormProps } from './types';

/**
 * A standalone payment step that picks between the Checkout Sessions form and the legacy
 * Payment Intents form, for surfaces that are not a SimplifiedSignup flow.
 */
const CheckoutSessionsPaymentForm = ({
	flowName,
	plan,
	pageName,
	hasFreeTrial,
	paymentScreenConfig,
	isCheckoutSessionsEnabled = false,
	...formProps
}: CheckoutSessionsPaymentFormProps) => {
	const flowConfig = useMemo(
		() => buildCheckoutSessionsFlowConfig({ flowName, plan, pageName, hasFreeTrial, paymentScreenConfig }),
		[flowName, plan, pageName, hasFreeTrial, paymentScreenConfig],
	);

	return (
		<SimplifiedSignupContextProvider
			flowConfig={flowConfig}
			isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
		>
			<PaymentElementsFormRefresh {...formProps} />
		</SimplifiedSignupContextProvider>
	);
};

export default CheckoutSessionsPaymentForm;
